import DOMPurify from 'dompurify'

/**
 * BlockPreview.tsx renders tenant-authored rich text (and any teammate's
 * content, since owner/admin/editor/author all share the same editor) via
 * dangerouslySetInnerHTML — unsanitized, this is a stored-XSS vector that
 * runs in the AUTHENTICATED dashboard origin, not just the public site.
 * Same mitigation as apps/sites/src/lib/sanitize.ts — keep both in sync if
 * the allowed tag/attribute set changes.
 */
export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['style', 'target'],
  })
}
